// A real video and what Bumpups made from it: its chapters beside a chat answer or a transcript excerpt.
// Used on the use-case and tool pages; the output is real, shortened for the page.
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import bumpMark from '../../assets/images/logo/bumpups-green-logo.png';

const fmt = s => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

export default function DemoCard({ videoId, title, by, seconds, chapters, question, answer, transcript, caption }) {
  const rows = (chapters || '').split('\n').filter(Boolean).map(line => {
    const i = line.indexOf(' - ');
    return i > 0 ? [line.slice(0, i), line.slice(i + 3)] : [line, ''];
  });
  // With no answer or transcript to show, the chapters take the wide column beside the video
  const chaptersOnly = !question && !transcript;
  const chapterList = rows.length > 0 && (
    <div className={`ucd-chapters${chaptersOnly ? ' ucd-chapters--main' : ''}`}>
      <p className="ucd-label">Timestamps</p>
      {rows.map(([t, text]) => (
        <p key={t + text} className="ucd-row"><span className="ucd-time">{t}</span><span>{text}</span></p>
      ))}
    </div>
  );
  return (
    <figure className="ucd">
      <div className="ucd-frame mk-glow">
        <div className="ucd-grid">
          <div className="ucd-side">
            <a href={`https://youtu.be/${videoId}`} target="_blank" rel="noopener noreferrer" className="ucd-thumb">
              <img src={`https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`} alt={`${title} on YouTube`} loading="lazy" width="320" height="180" />
              {seconds ? <span className="ucd-dur">{fmt(seconds)}</span> : null}
            </a>
            <p className="ucd-title">{title}</p>
            {by && <p className="ucd-by">{by}</p>}
            {!chaptersOnly && chapterList}
          </div>
          <div className="ucd-main">
            {chaptersOnly && chapterList}
            {question && (
              <>
                <p className="ucd-q">{question}</p>
                <div className="ucd-a">
                  <img src={bumpMark} alt="" className="ucd-mark" width="22" height="22" />
                  <ReactMarkdown className="ucd-md" remarkPlugins={[remarkGfm]}>{answer}</ReactMarkdown>
                </div>
              </>
            )}
            {transcript && (
              <div className="ucd-transcript">
                <p className="ucd-label">Transcript</p>
                {transcript.map(([t, text]) => (
                  <p key={t} className="ucd-row"><span className="ucd-time">[{t}]</span><span>{text}</span></p>
                ))}
                <p className="ucd-more">…</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <figcaption className="ucd-caption">{caption || 'Real output from Bumpups on a public YouTube video, shortened for this page.'}</figcaption>
    </figure>
  );
}
